import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=911f1188&scoped=true&"
import script from "./editArticle.vue?vue&type=script&lang=ts&"
export * from "./editArticle.vue?vue&type=script&lang=ts&"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=911f1188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911f1188",
  null
  
)

export default component.exports